import * as React from 'react'

const SvgFavoritesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={14} height={18} viewBox="0 0 14 18" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.5v14.219l-4.438-2.244L7 13.194l-.563.281L2 15.719V1.5h10zm0-1.25H2C1.31.25.75.81.75 1.5v16.25L7 14.625l6.25 3.125V1.5c0-.69-.56-1.25-1.25-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgFavoritesIcon
